import PubSub from '../services/pubsub-service';
import * as PubSubActionType from '../constants/pubus-action-type';
import * as ProjectTypeActionType from './constants';
import * as CommonActionType from '../constants/common-action-type';
import PhaseStore from './phase-reducers';

const defaultParams = {
  searchKey: '',
  skip: 1,
  take: 10,
  sort: { field: 'name', order: 'ascending' },
  status: 'all',
  totalRecord: 0,
  totalPage: 0
};

const ProjectProfile = {
  id: '',
  name: '',
  city: '',
  state: '',
  fullLocation: '',
  postalCode: '',
  costCode: '',
  projectOwnerId: '',
  projectOwnerName: '',
  projectOwnerEmail: '',
  status: true,
  emergencyPhone: '',
  regionId: '',
  marketId: ''
};

const ManageProjects = {
  items: [],
  params: defaultParams
};

const AssigneeNotice = [
  {
    content: '',
    order: 1,
    sendAfter: 0,
    emails: [],
    enable: true
  },
  {
    content: '',
    order: 2,
    sendAfter: 1,
    emails: [],
    enable: false
  },
  {
    content: '',
    order: 3,
    sendAfter: 1,
    emails: [],
    enable: false
  },
  {
    content: '',
    order: 4,
    sendAfter: 1,
    emails: [],
    enable: false
  }
];

const ProjectState = {
  request: {},
  action: '',
  SelectListRegions: [],
  SelectListMarkets: [],
  SelectListAccounts: [],
  SelectListTrades: [],
  ProjectProfile: ProjectProfile,
  ManageProjects: ManageProjects,
  dateTime: new Date(),
  ErrorMsg: [],
  IsSuccessStep1: false,
  IsCreate: true,
  ProjectList: [],
  UserSelectList: [],
  LotList: [],
  BuilderUserList: [],
  AssignmentUserList: null,
  ProjectSetting: null,
  NotifyRFS: null,
  BuilderName: null,
  AssigneeNotice: AssigneeNotice,
  ProjectListByUserId: [],
  DocumentTypes: [],
  ProjectDocument: {},
  ProjectDocumentSharedLot: {},
  InventoryItemSharedLot: [],
  ImportStatus: null,
  CustomTemplateList: [],
  DefaultTemplateList: [],
  CustomTemplateSectionList: [],
  customTemplateList: [],
  ProjectListCopy: [],
  SuggestCategoryInfo: [],
  SuggestInventoryItemInfo: [],
  categoryList: [],
  categoryProfile: {},
  templateCategoryProfile: [],
  templateInventoryItemProfile: [],
  createNewCategoryErrorMsg: null,
  categoryDropdownList: [],
  inventoryItemList: [],
  inventoryItemProfile: [],
  inventoryItemId: null,
  lotListAssign: [],
  removeImageAction: '',
  ProjectAWSCredential: null,
  suggestLocationTagsList: [],
  SuggestedGeneralTaskList: [],
  SuggestedSpecificTaskList: []
};

function ProjectStore(state = ProjectState, action) {
  switch (action.type) {
    case CommonActionType.COMMON_SELECT_LIST_ACCOUNT_SUCCESS:
      return processSelectListAccounts(state, action);
    case ProjectTypeActionType.GET_LIST_COPY_EOC_TEMPLATE_LIST_SUCCESS:
      return {
        ...state,
        ProjectListCopy: action.data

      };
    case CommonActionType.COMMON_SELECT_LIST_ITEM_TRADE_SUCCESS:
      return processSelectListTrades(state, action);
    case CommonActionType.COMMON_SELECT_LIST_REGION_SUCCESS:
      return processSelectListRegions(state, action);
    case CommonActionType.COMMON_SELECT_LIST_MARKET_SUCCESS:
      return processSelectListMarkets(state, action);
    case ProjectTypeActionType.SEARCH_PROJECT_SUCCESS:
      return processSearchSuccess(state, action);
    case ProjectTypeActionType.CREATE_PROJECT_SUCCESS:
      return {
        ...state,
        ProjectProfile: action.params
      };
    case ProjectTypeActionType.UPDATE_PROJECT_SUCCESS:
      return {
        ...state,
        ProjectProfile: action.params,
        IsSuccessStep1: true,
        ErrorMsg: []
      };
    case ProjectTypeActionType.GET_PROJECT_BY_ID_SUCCESS:
      return processGetProjectByIdSuccess(state, action);
    case ProjectTypeActionType.CREATE_UPDATE_PROJECT_ERROR:
      return {
        ...state,
        ErrorMsg: [action.data.error]
      };
    case ProjectTypeActionType.RESET_PROJECT:
      return processResetProject(state, action);
    case ProjectTypeActionType.SELECT_LIST_PROJECT_SUCCESS:
      return processProjectList(state, action);
    case ProjectTypeActionType.SELECT_LIST_LOT_SUCCESS:
      return processLotList(state, action);
    case ProjectTypeActionType.GET_LIST_PROJECT_ASSIGNMENT_USER_SUCCESS:
      return {
        ...state,
        AssignmentUserList: action.data
      };
    case ProjectTypeActionType.ASSIGN_USER_TO_PROJECT_SUCCESS:
      return {
        ...state,
        AssignmentUserList: action.data
      };
    case ProjectTypeActionType.GET_LIST_BUILDER_USER_SUCCESS:
      return {
        ...state,
        BuilderUserList: action.data
      };
    case ProjectTypeActionType.RESET_BUILDER_USER_LIST:
      return {
        ...state,
        BuilderUserList: []
      };
    case ProjectTypeActionType.GET_LIST_USER_SUCCESS:
      return {
        ...state,
        UserSelectList: action.data
      };
    case ProjectTypeActionType.GET_PROJECT_SETTING_SUCCESS:
      return {
        ...state,
        ProjectSetting: action.data
      };
    case ProjectTypeActionType.GET_PROJECT_SETTING_NOTICE_RFS_SUCCESS:
      return {
        ...state,
        NotifyRFS: action.data
      };
    case ProjectTypeActionType.SETTING_UPDATE_ASSIGNEE_NOTICE_SUCCESS:
      action.data.map(item => {
        item.emails = item.emails ? item.emails.split(',') : [];
      });
      return {
        ...state,
        AssigneeNotice: action.data.sort(compare)
      };
    case ProjectTypeActionType.GET_PROJECT_BY_USER_ID_ASYNC:
      return {
        ...state,
        ProjectListByUserId: []
      };

    case ProjectTypeActionType.GET_PROJECT_BY_USER_ID_SUCCESS:
      return {
        ...state,
        ProjectListByUserId: action.data
      };
    case ProjectTypeActionType.GET_LIST_PROJECT_DOCUMENT_TYPE_SUCCESS:
      return {
        ...state,
        DocumentTypes: action.data
      };
    case ProjectTypeActionType.GET_PROJECT_DOCUMENT_BY_DOCUMENT_TYPE_SUCCESS:
      return processGetProjectDocument(state, action);
    case ProjectTypeActionType.UPLOAD_PROJECT_DOCUMENT_TO_SERVER_SUCCESS:
      return processUploadProjectDocumentSuccess(state, action);
    case ProjectTypeActionType.GET_PROJECT_DOCUMENT_SHARE_LOT_SUCCESS:
      return {
        ...state,
        ProjectDocumentSharedLot: action.data
      };
    case ProjectTypeActionType.GET_IMPORT_STATUS_BY_PROJECT_SUCCESS:
      return {
        ...state,
        ImportStatus: action.data
      };
    case ProjectTypeActionType.GET_LIST_DEFAULT_CUSTOM_TEMPLATE_SUCCESS:
      return {
        ...state,
        DefaultTemplateList: action.data
      };
    case ProjectTypeActionType.GET_LIST_DEFAULT_CUSTOM_TEMPLATE2_SUCCESS:
      return {
        ...state,
        DefaultTemplateList2: action.data
      };

    case ProjectTypeActionType.GET_CUSTOM_TEMPLATE_DETAIL_SUCCESS:
      return {
        ...state,
        customTemplateList: action.data
      };
    case ProjectTypeActionType.GET_CUSTOM_TEMPLATE_DETAIL2_SUCCESS:
      return {
        ...state,
        customTemplateList2: action.data
      };
    case ProjectTypeActionType.GET_BUILDER_NAME_SUCCESS:
      return {
        ...state,
        BuilderName: action.data
      };
    case ProjectTypeActionType.SUGGEST_INFORMATION_CATEGORY_SUCCESS:
      return {
        ...state,
        SuggestCategoryInfo: action.data,
        createNewCategoryErrorMsg: null
      };
    case ProjectTypeActionType.GET_LIST_CATEGORY_PROFILE_IMAGES_ASYNC:
      return {
        ...state,
        removeImageAction: action.type
      };
    case ProjectTypeActionType.GET_LIST_CATEGORY_PROFILE_IMAGES_SUCCESS:
      return {
        ...state,
        removeImageAction: action.type,
        categoryProfile: {...state.categoryProfile, images: action.data}
      };
    case ProjectTypeActionType.GET_LIST_CATEGORY_SUCCESS:
      return {
        ...state,
        categoryList: action.data,
        createNewCategoryErrorMsg: null
      };
    case ProjectTypeActionType.GET_CATEGORY_PROFILE_DETAILS_SUCCESS:
      return {
        ...state,
        removeImageAction: action.type,
        categoryProfile: action.data
      };

    case ProjectTypeActionType.GET_CATEGORY_PROFILE_DETAILS_ASYNC:
      return {
        ...state,
        removeImageAction: action.type,
        categoryProfile: action.data
      };
    case ProjectTypeActionType.GET_SELECTED_TEMPLATE_CATEGORY_SUCCESS:
      return {
        ...state,
        templateCategoryProfile: action.data
      };
    case ProjectTypeActionType.CREATE_NEW_CATEGORY_ERROR:
      return {
        ...state,
        createNewCategoryErrorMsg: action.data.error
      };
    case ProjectTypeActionType.GET_LIST_CATEGORY_DROPDOWN_SUCCESS:
      return {
        ...state,
        categoryDropdownList: action.data
      };
    case ProjectTypeActionType.GET_LIST_INVENTORY_ITEM_SUCCESS:
      return {
        ...state,
        request: action.request,
        action: action.type,
        inventoryItemList: action.data
      };
    case ProjectTypeActionType.GET_LIST_INVENTORY_ITEM_ASYNC:
      return {
        ...state,
        request: action.params,
        action: action.type
      };
    case ProjectTypeActionType.GET_INVENTORY_ITEM_PROFILE_SUCCESS:
      return {
        ...state,
        action: action.type,
        inventoryItemId: action.data.id,
        inventoryItemProfile: action.data
      };
    case ProjectTypeActionType.GET_INVENTORY_ITEM_PROFILE_ASYNC:
      return {
        ...state,
        action: action.type
      };
    case ProjectTypeActionType.GET_LIST_PHASE_TO_LOT_INVENTORY_ITEM_SUCCESS:
      return {
        ...state,
        InventoryItemSharedLot: action.data
      };
    case ProjectTypeActionType.GET_LIST_LOT_ASSIGN_INVENTORY_ITEM_SUCCESS:
      return {
        ...state,
        lotListAssign: action.data
      };
    case ProjectTypeActionType.CREATE_NEW_INVENTORY_ITEM_SUCCESS:
      return {
        ...state,
        inventoryItemId: action.data
      };
    case ProjectTypeActionType.GET_SUGGEST_TEMPLATE_NAME_SUCCESS:
      return {
        ...state,
        SuggestInventoryItemInfo: action.data
      };
    case ProjectTypeActionType.GET_SUGGEST_DATA_SUCCESS:
      return {
        ...state,
        templateInventoryItemProfile: action.data
      };
    case ProjectTypeActionType.GET_INVENTORY_ITEM_IMAGES_SUCCESS:
      return {
        ...state,
        action: action.type,
        inventoryItemProfile: {...state.inventoryItemProfile, images: action.data}
      };
    case ProjectTypeActionType.GET_INVENTORY_ITEM_IMAGES_ASYNC:
      return {
        ...state,
        action: action.type
      };
    case ProjectTypeActionType.GET_INVENTORY_ITEM_ATTACHMENT_SUCCESS:
      return {
        ...state,
        action: action.type,
        inventoryItemProfile: {...state.inventoryItemProfile, attachments: action.data}
      };
    case ProjectTypeActionType.GET_INVENTORY_ITEM_ATTACHMENT_ASYNC:
      return {
        ...state,
        action: action.type
      };
    case ProjectTypeActionType.SETUP_PROJECT_DOCUMENT_AWS_SUCCESS:
      return {
        ...state,
        ProjectAWSCredential: action.data
      };
    case ProjectTypeActionType.SUGGEST_LOCATION_TAGS_HOME_INVENTORY_SUCCESS:
      return {
        ...state,
        suggestLocationTagsList: action.data
      };
    case ProjectTypeActionType.GET_INVENTORY_TEMPLATE_LIST_SUCCESS:
      return {
        ...state,
        InventoryTemplateList: action.data
      };
    case ProjectTypeActionType.GET_INVENTORY_ITEM_TEMPLATE_LIST_SUCCESS:
      return {
        ...state,
        InventoryItemTemplateList: action.data
      };
    case ProjectTypeActionType.GET_REQUEST_TYPE_TO_MAPPING_SUCCESS:
      return {
        ...state,
        RequestTypeToMappingList: action.data
      };
    case ProjectTypeActionType.GET_MAINTENANCE_SETTINGS_TIMEZONE_SUCCESS:
      return {
        ...state,
        TimeZoneList: action.data
      };
    case ProjectTypeActionType.GET_MAINTENANCE_SETTINGS_SUCCESS:
      return {
        ...state,
        MaintenanceSchedule: {...state.MaintenanceSchedule, Settings: action.data}
      };
    case ProjectTypeActionType.GET_MAINTENANCE_LOT_LIST_SUCCESS:
      return {
        ...state,
        LotsInProject: action.data
      };
    case ProjectTypeActionType.GET_MAINTENANCE_TASK_LIST_SUCCESS:
      return {
        ...state,
        MaintenanceTaskList: action.data
      };
    case ProjectTypeActionType.GET_MAINTENANCE_GENERAL_TASK_SUCCESS:
    case ProjectTypeActionType.GET_MAINTENANCE_SPECIFIC_TASK_SUCCESS:
      return {
        ...state,
        MaintenanceTaskDetail: action.data
      };
    case ProjectTypeActionType.GET_MAINTENANCE_SUGGESTED_GENERAL_TASK_SUCCESS:
      return {
        ...state,
        SuggestedGeneralTaskList: action.data
      };
    case ProjectTypeActionType.GET_MAINTENANCE_SUGGESTED_SPECIFIC_TASK_SUCCESS:
      return {
        ...state,
        SuggestedSpecificTaskList: action.data
      };
    case ProjectTypeActionType.GET_MAINTENANCE_TASK_REMINDER_LIST_SUCCESS:
      return {
        ...state,
        MaintenanceTaskReminderList: action.data
      };

    default:
      return state;
  }
}

const compare = (a, b) => {
  if (a.order < b.order) {
    return -1;
  }
  if (a.order > b.order) {
    return 1;
  }
  return 0;
};

const processSearchSuccess = (state, action) => {
  var result = action.data;
  var manageProjects = {
    items: result.data.items,
    params: {
      totalRecord: result.data.totalRecord,
      totalPage: result.data.totalPage,
      skip: result.params.skip + 1,
      take: result.params.take,
      status: result.params.status,
      name: result.params.name,
      sort: { field: result.params.sortField, order: result.params.sortOrder }
    }
  };
  return {
    ...state,
    ManageProjects: manageProjects,
    ErrorMsg: [],
    IsSuccessStep1: false,
    IsCreate: true
  };
};

const processGetProjectByIdSuccess = (state, action) => {
  PubSub.publish(PubSubActionType.PUBLISH_PROJECT_INFORMATION, {
    project: action.data
  });

  return {
    ...state,
    ProjectProfile: action.data,
    ErrorMsg: [],
    IsSuccessStep1: false,
    IsCreate: false
  };
};

const processSelectListAccounts = (state, action) => {
  return {
    ...state,
    SelectListAccounts: action.data
  };
};

const processSelectListRegions = (state, action) => {
  return {
    ...state,
    SelectListRegions: action.data
    // SelectListMarkets: []
  };
};

const processSelectListMarkets = (state, action) => {
  return {
    ...state,
    SelectListMarkets: action.data
  };
};

const processSelectListTrades = (state, action) => {
  return {
    ...state,
    SelectListTrades: action.data
  };
};

const processResetProject = state => {
  return {
    ...state,
    SelectListRegions: [],
    SelectListMarkets: [],
    SelectListAccounts: [],
    ErrorMsg: [],
    ProjectProfile: ProjectProfile,
    dateTime: new Date(),
    IsSuccessStep1: false,
    IsCreate: true,
    ManageProjects: ManageProjects
  };
};

const processProjectList = (state, action) => {
  var userSelectList = [];

  action.data.map(item => {
    if (item.extensionValue) {
      userSelectList.push(item.extensionValue);
    }
  });
  return {
    ...state,
    ProjectList: action.data,
    UserSelectList: userSelectList
  };
};

const processLotList = (state, action) => {
  action.data.map(item => {
    item.text = item.text + ', ' + item.extensionValue.streetAddress;
  });
  return {
    ...state,
    LotList: action.data
  };
};

const processGetProjectDocument = (state, action) => {
  let currentProjectDocument = { ...state.ProjectDocument };

  const { documentTypeId, documentList } = action.data;

  currentProjectDocument[documentTypeId] = documentList;

  return {
    ...state,
    ProjectDocument: currentProjectDocument
  };
};

const processUploadProjectDocumentSuccess = (state, action) => {
  let currentProjectDocument = { ...state.ProjectDocument };

  const { documentTypeId, documentItem } = action.data;

  currentProjectDocument[documentTypeId].push(documentItem);

  return {
    ...state,
    ProjectDocument: currentProjectDocument
  };
};

export { PhaseStore, ProjectStore };



// WEBPACK FOOTER //
// ./src/Projects/reducers.js